import React from "react";
import { useFormState, useFormContext } from 'react-hook-form';
import { useBlocker } from "../../hooks/useBlocker";

export default function HookFormDirtyCheck() {
  // const { control} = useFormContext()
  // const { isDirty, submitCount } = useFormState({control: control});

  // const message = "Are you sure you want to leave? You have unsaved changes on form.";

  // const blocker = React.useCallback(
  //   ( tx ) => {
  //     // eslint-disable-next-line no-alert
  //     if ( window.confirm( message ) ) tx.retry();
  //   },
  //   [ message ]
  // );

  // useBlocker(blocker, isDirty && submitCount === 0)

  return null;
};
